module.exports = __webpack_public_path__ + "img/sergeant-reason-icon6.73e19b2f.png";